/* =========================================================================
   HLLPRO — SHARPEN IMAGES  v1.0
   Đi kèm hllpro-skin.css

   VẤN ĐỀ: skin làm khung trang rộng hơn nên ô ảnh to hơn, nhưng thuộc tính
   "sizes" của ảnh đã được Shopify ghi cứng sẵn trong HTML theo layout cũ.
   Trình duyệt vì thế vẫn tải bản ảnh nhỏ -> ảnh bị phóng to -> mờ.

   CÁCH SỬA: sau khi trang dựng xong, script đo bề rộng thật của từng ô ảnh,
   và CHỈ khi bản ảnh đang tải nhỏ hơn mức cần thì mới xin trình duyệt tải
   bản lớn hơn. Ảnh nào đã đủ nét thì không đụng tới (không tốn thêm dung lượng).

   KHÔNG đổi nội dung, KHÔNG đụng file ảnh gốc, KHÔNG sửa section nào.
   Gỡ bỏ: xoá dòng script này trong theme.liquid là xong.
   ========================================================================= */
(function () {
  'use strict';

  var ASK_MARGIN = 1.5;   // xin dư 50% cho chắc nét (Shopify tự cắt trần ở kích thước ảnh gốc)
  var NEAR = 600;         // chỉ xử lý ảnh trong hoặc gần khung nhìn (px)
  var asked = new WeakMap();

  function currentWidth(img) {
    var m = /[?&]width=(\d+)/.exec(img.currentSrc || '');
    return m ? parseInt(m[1], 10) : 0;
  }

  function fixOne(img) {
    var box = img.getBoundingClientRect().width;
    if (!box) return;

    var have = currentWidth(img);
    if (!have) return;                                  // không phải ảnh Shopify -> bỏ qua

    var need = Math.ceil(box * (window.devicePixelRatio || 1));
    if (have >= need) return;                           // đã đủ nét -> không làm gì

    var ask = Math.ceil(box * ASK_MARGIN);
    if ((asked.get(img) || 0) >= ask) return;           // đã xin rồi -> khỏi xin lại
    asked.set(img, ask);
    img.sizes = ask + 'px';
  }

  function scan() {
    var imgs = document.querySelectorAll('img[srcset][sizes]');
    var h = window.innerHeight;
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      if (r.bottom > -NEAR && r.top < h + NEAR) fixOne(imgs[i]);
    }
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(scan, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule);

  // Ảnh nạp thêm sau: đổi biến thể, quick view, lọc sản phẩm, theme editor...
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:block:select', schedule);
})();
